import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, withLatestFrom } from 'rxjs';
import { debounceTime, mergeMap } from 'rxjs/operators';

import {
  setListScrollState,
  setWidgetsCollapseState,
} from '@main-application/turnovers/components/turnover-list/store/actions/turnover-list.actions';
import { selectTurnoverWidgetsCollapseState } from '@main-application/turnovers/components/turnover-list/store/selectors/turnover-list.selectors';

@Injectable()
export class TurnoverListEffects {
  setListScrollState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setListScrollState),
      withLatestFrom(this.store.select(selectTurnoverWidgetsCollapseState)),
      debounceTime(100),
      mergeMap(([action, state]) => {
        if (!state.manually || !state.collapsed) {
          if (action.position > 200) {
            return of(setWidgetsCollapseState({ collapsed: true, manually: false }));
          }
          if (action.position < 100) {
            return of(setWidgetsCollapseState({ collapsed: false, manually: false }));
          }
        }
        return of(setWidgetsCollapseState(state));
      })
    )
  );

  constructor(private actions$: Actions, private store: Store<{}>) {}
}
